<template>
	<div id='usuAdd'>
		<h2>AGREGAR USUARIO {{empresa}}</h2>
        <a @click="$router.go(-1)">regresar</a>
        <br>
		<form v-on:submit.prevent= 'guardarUsuario'>
		<table align="center">
			<tr>
				<td align="left">nombre completo </td><td><input type="text" name="nombreCompleto" required autofocus minlength="5" v-model="usuarios.nombreCompleto"></td>
			</tr>
			<tr>
				<td align="left">email </td><td><input type="email" name="email" required v-model="usuarios.email"></td>
			</tr>
			<tr>
				<td align="left">password </td><td><input type="password" name="pase1" required minlength="4" v-model="usuarios.pase1"></td>
			</tr>
			<tr>
				<td align="left">password(otra vez) </td><td><input type="password" name="pase2" minlength="4" required v-model="usuarios.pase2"></td>
			</tr>						
			<tr>
				<td align="left">celular </td><td><input type="tel" name="celular" required minlength="10" v-model="usuarios.celular"></td>
			</tr>
			<tr>
				<td align="left">whatsapp </td><td><input type="tel" name="whatsapp" v-model="usuarios.whatsapp"></td>
			</tr>
			<tr>
				<td align="left">permisos </td>
				<td>
					<select name="permisos" v-model="seleccion" v-on:change='agregaSeleccion(seleccion)'>
						<option disabled value="">Seleccione para agregar</option>
						<option>Propiedades Consulta</option>
						<option>Propiedades Altas</option>
						<option>Propiedades Ver detalle</option>
						<option>Propiedades Editar</option>

						<option>Inquilinos Consulta</option>
						<option>Inquilinos Altas</option>
						<option>Inquilinos Ver Detalle</option>				
						<option>Inquilinos Editar</option>

						<option>Movimientos Consulta</option>
						<option>Movimientos Altas</option>

						<option>Contratos Consulta</option>
						<option>Contratos Altas</option>
						<option>Contratos Ver detalle</option>
						<option>Contratos Editar</option>

						<option>Movimientos Altas</option>
						<option>Movimientos Consulta</option>

						<option>Cobros Consulta</option>				
						<option>Cobros Altas</option>

						<option>Reportes de Propiedades </option>
						<option>Reportes de Inquilinos</option>
						<option>Reportes de Movimientos</option>
						<option>Reportes de Contratos</option>

						<option>Usuarios Altas</option>
						<option>Usuarios Editar</option>

					</select>
					</br>{{cadenaSeleccion}}

				</td>
			</tr>
			<td></td><td>
				<input type="submit" name="agregandoUsuario">
			</td>

		</table>
		</form>
	</div>
</template>

<script>
	import axios from 'axios';
	export default{
			name:'agrega-usuario',
			mounted(){
				this.autorizar();
			},
		    props: ['vector', 'empresa'],  
			data(){
				return {
					usuarios:{
						nombreCompleto:'',
						email:'',
						pase1: '',
						pase2: '',
						clave: '',
						celular:'',
						whatsapp:'',
						status:'',
						fechaModifica:'',
						quienModifico:''
						},
					seleccion:'',
					cadenaSeleccion:''					
				};
			},
			methods:{
				autorizar(){
			 		// checa si tiene autorizacion
			  		if(!this.vector.includes('MASTERGGUV')){
				  		if(!this.vector.includes('Usuarios Altas')){
				  			alert('Seccion no autorizada');
							document.getElementById('usuAdd').hidden = true;
				  			return;
				  		}
				  	}
			  	},
				agregaSeleccion(selec){
					if(!this.cadenaSeleccion.includes(selec)){
						this.cadenaSeleccion +='-' + selec + '\n';
					}
				},
				guardarUsuario(){
					var usuarios1= this.usuarios;
					var router= this.$router;
					if(usuarios1.pase2 != usuarios1.pase1){
						//alert('Su clave debe coincidir');					
						return;
					}

					// primero checamos is existe o no
					axios.post('https://www.directodo.com/Rentus/accesosdb/checaUsuario.php?elmail='+usuarios1.email).
					then((respue) => {
		  		        if (respue.statusText == 'OK'){
		  		        	this.mail2 = respue.data; // pasamos de objeto a string normal.
		  		        	if(this.mail2.includes(usuarios1.email)){
		  		        		alert('Usuario mail ya existe');
		  		        		return;// ya existe
		  		        	};

		  		        	// no existe, es nuevo entonces lo da de alta
		  		        	axios.post('https://www.directodo.com/Rentus/accesosdb/agregaUsuario.php?nombreCompleto='+usuarios1.nombreCompleto+'&email='+usuarios1.email+'&celular='+usuarios1.celular+'&suclave='+usuarios1.pase1+'&whatsapp='+usuarios1.whatsapp+'&status=A'+'&fechaModifica='+this.fechaActual()+'&quienModifico='+'MASTER'+'&cadenaPermisos='+this.cadenaSeleccion)
		  		          			.then((respue) => {
		  		          				if (respue.statusText == 'OK'){
		  		          					router.push('/inq')
		  		          				}
		  			 	  			})
		  		          			.catch((error) =>{
		  		          				console.log('Este usuario ya existe '+error);
		  		          			});

		  		       	}
		  		  	})
		  		    .catch((error) =>{
		  		    	console.log('Error acceso a base '+error);
		  		    });					
				},

				fechaActual(){      
				    var currentDate = new Date() //hoy
				    var day = currentDate.getDate();
				    var month = currentDate.getMonth() + 1;
				    var year = currentDate.getFullYear();
				    var my_date = year+"-"+month+"-"+day;
				    return my_date;    
				}

			}
	}
</script>


// WEBPACK FOOTER //
// src/Usuario-agregar.vue